import React from 'react'
import demoImg from "../images/demoImg.png"
import { Button } from '@mui/material'
import arrow_btn from '../images/arrow_btn.svg';
import blueBg from "../images/blueBg.png"
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const HomeTakeExport = (props) => {
    const { t } = useTranslation();
    const navigate = useNavigate()

    return (

        <div className={`container mx-auto px-2 xl:max-w-[1000px] 3xl:max-w-[1200px] justify-between ${props.className}`} >
            <div
                style={{
                    backgroundImage: `url('${blueBg}')`
                }}
                className="flex bg-center rounded-[24px] sm:rounded-[0px] bg-no-repeat sm:bg-[length:100%_100%] sm:pl-[34px] relative w-[100%] min-h-[240px] sm:min-h-[270px] "
            >
                <div className='h-[100%] p-5 sm:pl-[20px] 3xl:pl-[80px] w-[100%] md:w-[60%] z-[1] text-center md:text-left m-[auto] md:mx-auto' >
                    {/* <h1 className='text-[20px] sm:text-[30px] 3xl:text-[40px] font-[700]'>Talk to an expert </h1> */}
                    <span className='sora text-[14px] sm:text-[18px] text-[#141619]'>{props.content}</span>
                    <div className='pt-3 lg:pt-8 flex justify-center md:block'>
                        <div className="requestDemoBtnOuter" onClick={() => navigate("/contact-us")}>
                            <Button className="requestDemoBtn sora" >
                                {t("book_demo")}
                                <img draggable="false" src={arrow_btn} className="w-[9px] sm:w-[12px] ml-[4px]" alt="Arrow_up_small" />
                            </Button>
                        </div>
                    </div>
                </div>
                <img draggable="false" src={demoImg} alt='lockImage' className='hidden md:flex w-[386px] p-[20px]' />
            </div>
        </div>
    )
}

export default HomeTakeExport